import React, {useState, forwardRef, useImperativeHandle} from "react";

import css from "./index.module.scss";
import CheckmarkSvg from "/public/images/icons/checkmark.svg";

export default forwardRef(({
  onChange = () => {
  },
  name = "",
  label = "",
  type = "checkbox",
  validators = [],
  className = "",
  initialValue = false,
}, ref) => {
  const [message, setMessage] = useState("");
  const [value, setValue] = useState(initialValue);
  const [validity, setValidity] = useState(null);

  let finalClassName = `${css.checkbox}`;


  finalClassName += ` ${className}`;

  async function validate(newValue){
    for (let validator of validators){
      if (await validator.test(newValue)){
        let result = false;
        if (validator.class === "valid"){
          result = true;
        } else if (validator.class === "invalid") {
          result = false;
        }
        setMessage(validator.message);
        setValidity(result);
        return result;
      }
    }
  }

  useImperativeHandle(ref, () => ({
    isValid() {
      return validate(value);
    },
    getValue() {
      return value;
    },
    setValid(newValidity) {
      setValidity(newValidity);
    },
    setMessage(newMessage) {
      setMessage(newMessage);
    },
  }));


  return <div className={finalClassName}>
    <label>
      <input
        type={type}
        className={css.input}
        name={name}
        value={value}
        onChange={(event) => {
          validate(event.target.checked);
          setValue(event.target.checked);
          onChange(event.target.checked);
        }}
      />
      <div className={css.checkVisible}>
        <CheckmarkSvg/>
      </div>
      {label && <div className={css.label}>{label}</div>}
    </label>
    <div className={css.message}>{message}</div>
  </div>;
});
